import React, { useState } from "react";

import LogoutIcon from "../../../assets/svgs/Logout";
import DashboardIcon from "../../../assets/svgs/Dashboard";
import PerksIcon from "../../../assets/svgs/Team";
import CelendarIcon from "../../../assets/svgs/Celendar";
import WalletIcon from "../../../assets/svgs/Wallet";
import InventoryIcon from "../../../assets/svgs/Inventory";
import OrdersIcon from "../../../assets/svgs/Orders";
import PlusIcon from "../../../assets/svgs/Plus";
import MinusIcon from "../../../assets/svgs/Minus";
import RemoveIcon from "../../../assets/svgs/Remove";
import Home from "../../../assets/svgs/Home";
import TemplateIcon from "../../../assets/svgs/Template";
import Archive from "../../../assets/svgs/Archive";
import Puzzle from "../../../assets/svgs/Puzzle";
import Book from "../../../assets/svgs/Book.jsx";
import Swatch from "../../../assets/svgs/Swatch";
import Database from "../../../assets/svgs/Database";
import CreaditCard from "../../../assets/svgs/CreaditCard";
import Document from "../../../assets/svgs/Document";
import Table from "../../../assets/svgs/TableIcon";
import Users from "../../../assets/svgs/Users";
import Notification from "../../../assets/svgs/Notification";

import LeftNavLink from "./LeftNavLink";

const LeftNavbar = ({ LeftNavRef }) => {
  const hideLeftNav = () => {
    LeftNavRef?.current.classList.add("slide-left");
  };

  const [showText, setShowText] = useState(false);
  return (
    <div
      ref={LeftNavRef}
      style={{
        minWidth: `${showText ? "170px" : "85px"}`,
      }}
      className="sticky z-30 top-0 h-screen hidden md:flex left-0 bg-gradient-to-t to-[#DADADA] from-white flex-col items-end justify-end border-r"
    >
      {/* Left Nav Link Text Toggle 👇 */}
      <button
        onClick={() => setShowText((p) => !p)}
        className="shadow-xl w-7 h-7 rounded-full  flex justify-center items-center bg-gradient-to-tr from-pink-700 to-pink-500 text-white absolute top-1 right-1"
      >
        {showText ? <MinusIcon /> : <PlusIcon />}
      </button>

      {/* Left Navbar Remover Button for mobile devices 👇 */}
      <div
        onClick={hideLeftNav}
        className="flex md:hidden absolute top-5 -right-8 w-8 h-8 bg-red-500 text-white rounded-r-full items-center justify-center"
      >
        <RemoveIcon />
      </div>

      <div
        style={{ height: "80vh" }}
        className="w-full my-auto overflow-scroll scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch space-y-6"
      >
        <LeftNavLink
          Icon={Home}
          active={false}
          showText={showText}
          text="Home"
          homepage={true}
        />

        <LeftNavLink
          Icon={DashboardIcon}
          active={false}
          showText={showText}
          text="Dashboard"
        />

        <LeftNavLink
          Icon={PerksIcon}
          active={false}
          showText={showText}
          text="Perks"
        />

        <LeftNavLink
          Icon={Puzzle}
          active={false}
          showText={showText}
          text="Intergrations"
        />

        <LeftNavLink
          Icon={WalletIcon}
          active={false}
          showText={showText}
          text="Payroll"
        />

        <LeftNavLink
          Icon={InventoryIcon}
          active={false}
          showText={showText}
          text="Billing"
        />

        <LeftNavLink
          Icon={CelendarIcon}
          active={false}
          showText={showText}
          text="Documents"
        />

        <LeftNavLink
          Icon={OrdersIcon}
          active={false}
          showText={showText}
          text="Service Request"
        />

        <LeftNavLink
          Icon={Table}
          active={false}
          showText={showText}
          text="Tasks"
        />

        <LeftNavLink
          Icon={Database}
          active={false}
          showText={showText}
          text="Data"
        />

        <LeftNavLink
          Icon={Notification}
          active={false}
          showText={showText}
          text="Notifications"
        />

        <LeftNavLink
          Icon={Users}
          active={false}
          showText={showText}
          text="Company Employee"
        />

        <LeftNavLink
          Icon={Book}
          active={false}
          showText={showText}
          text="Notes"
        />

        <LeftNavLink
          Icon={Swatch}
          active={false}
          showText={showText}
          text="Company List"
        />

        <LeftNavLink
          Icon={Archive}
          active={false}
          showText={showText}
          text="Reports"
        />

        <LeftNavLink
          Icon={TemplateIcon}
          active={false}
          showText={showText}
          text="Template"
        />

        <LeftNavLink
          Icon={Document}
          active={false}
          showText={showText}
          text="Documents Dashboard"
        />

        <LeftNavLink
          Icon={CreaditCard}
          active={false}
          showText={showText}
          text="Currency"
        />
        <button
          className={`group cursor-pointer py-2 w-full flex items-center space-x-3 ${
            showText ? "justify-start pl-3" : "justify-center"
          } `}
        >
          <LogoutIcon />
          {showText && (
            <b className="text-xs text-gray-400 group-hover:text-[#BA004F]">
              Log Out
            </b>
          )}
        </button>
      </div>
    </div>
  );
};

export default LeftNavbar;
